import { h } from 'preact';
import { MetricCard } from '../MetricCard';
import { T } from '../../../styles/tokens';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'MetricCard',
  category: '📋 Cards',
  description: 'Card de métrica com ícone, valor, label, trend e subtítulo',
  usedIn: ['Integrations', 'AffiliatesPanel', 'ReferralDashboard'],
  example: () => (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12 }}>
      <MetricCard value="1,234" label="Usuarios" color={T.primary} icon="U" />
      <MetricCard value="R$ 5.6k" label="Receita" color={T.success} icon="$" trend={12.5} subtitle="vs. mes anterior" />
      <MetricCard value="89%" label="Conversao" color={T.warning} icon="%" trend={-3.2} />
      <MetricCard value="12" label="Erros" color={T.danger} icon="!" subtitle="Ultimas 24h" />
    </div>
  ),
};
